var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessMentorship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9086 6.26568H17.2139M14 4.5625H21M8.47939 9.35901C9.88625 9.35901 11.0282 8.2304 11.0282 6.84357C11.0282 5.45674 9.88403 4.32812 8.47939 4.32812C7.07475 4.33035 5.93055 5.45674 5.93055 6.84357C5.92387 7.50248 6.17987 8.12578 6.64734 8.59993C7.13262 9.08966 7.78263 9.35901 8.47939 9.35901ZM17.9482 10.3465L18.6561 8.95298C18.8142 8.64133 18.8431 8.30297 18.734 8.02471C18.6495 7.80879 18.4892 7.64628 18.2844 7.5706C18.1953 7.53721 18.1018 7.5194 18.0061 7.5194C17.6321 7.5194 17.2804 7.78207 17.02 8.25622L16.4189 9.4249C15.6866 9.48501 15.2903 10.1128 15.0944 10.4222L14.066 12.0873L12.3809 10.9831L12.3675 10.9742C11.3569 10.3621 10.4776 9.89237 9.16868 9.89237C9.07741 9.89237 8.98837 9.89683 8.91046 9.90128C8.85258 9.9035 8.79916 9.90573 8.75909 9.90573H8.21593L8.17809 9.90796C6.48628 10.1016 5.57138 10.8563 5.10168 11.4528C4.38266 12.37 4.35372 13.3049 4.36485 13.5854V19.2285C4.36485 19.5112 4.4717 19.7783 4.67205 19.9964L4.68986 20.0143C4.89465 20.2146 5.18182 20.3281 5.47788 20.3281H10.9518C11.5661 20.3281 12.067 19.8339 12.067 19.224V15.2839L13.4249 15.8916C13.6319 16.0051 13.8545 16.0608 14.0838 16.0608C14.8206 16.0608 15.4462 15.4686 15.7845 14.9166L17.8013 11.6621C18.1263 11.1301 18.1219 10.765 17.9482 10.3465Z",
    stroke: "#0B0A0A",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessMentorship);
export default __webpack_public_path__ + "static/media/business-mentorship.5876e3831450fa690b3bc404c7334461.svg";
export { ForwardRef as ReactComponent };